import ResponsiveField from '../responsivefield'
import Form from '@admin/components/form'
import LinkedField from '../linkedfield'
import ColorField from '../colorfield'
import PropTypes from 'prop-types'
import React from 'react'

const Color = (props) => <ResponsiveField { ...props } component={ ColorField } />
const Spacing = (props) => <ResponsiveField { ...props } component={ LinkedField } />

class DividerStyleField extends React.Component {

  static propTypes = {
    defaultValue: PropTypes.object,
    device: PropTypes.string,
    theme: PropTypes.object,
    value: PropTypes.object,
    onChange: PropTypes.func,
    onReady: PropTypes.func
  }

  static defaultProps = {
    onChange: () => {},
    onReady: () => {}
  }

  state = {
    divider: null
  }

  _handleChange = _.debounce(this._handleChange.bind(this), 100, { trailing: true })
  _handleUpdate = this._handleUpdate.bind(this)

  render() {
    if(!this.state.divider) return null
    return (
      <div className="mjson-designer-stylefield">
        <Form { ...this._getForm() } />
      </div>
    )
  }

  componentDidMount() {
    const defaultValue = this._getDefaultValue()
    this._handleSet(defaultValue)
    this.props.onReady()
  }

  componentDidUpdate(prevProps, prevState) {
    const { value } = this.props
    const { divider } = this.state
    if(!_.isEqual(divider, prevState.divider)) {
      this._handleChange()
    }
    if(!_.isEqual(value, prevProps.value)) {
      this._handleSet(value)
    }
  }

  _getForm() {
    const { device, theme } = this.props
    const { divider } = this.state
    return {
      inline: true,
      onChange: this._handleUpdate,
      sections: [
        {
          fields: [
            { label: 't(Background Color)', name: 'backgroundColor', device, theme, collapsing: true, collapsed: true, type: Color, value: divider.backgroundColor },
            { label: 't(Line Color)', name: 'lineColor', device, theme, collapsing: true, collapsed: true, type: Color, value: divider.lineColor },
            { label: 't(Icon Color)', name: 'iconColor', device, theme, collapsing: true, collapsed: true, type: Color, value: divider.iconColor },
            { label: 't(Margin)', name: 'margin', device, collapsing: true, collapsed: true, type: Spacing, units: [
              { name: 'px', min: 0, max: 100, step: 1 }
            ], types: ['top','right','bottom','left'], nullValues: ['0px'], defaultValue: '0px', value: divider.margin }
          ]
        }
      ]
    }
  }

  _getDefaultValue() {
    const { defaultValue, value } = this.props
    return !_.isNil(value) ? value : !_.isNil(defaultValue) ? defaultValue : null
  }

  _handleChange() {
    const { divider } = this.state
    this.props.onChange(divider)
  }

  _handleSet(divider) {
    this.setState({
      divider: {
        backgroundColor: null,
        lineColor: {
          value: 'default',
          opacity: '80%'
        },
        iconColor: {
          value: '@accent1'
        },
        ...divider
      }
    })
  }

  _handleUpdate(divider) {
    this.setState({ divider })
  }

}

export default DividerStyleField
